import React from "react";
import ReactDOM from "react-dom";
import "./theme/styles.scss";
import "./theme/print.scss";
import "./animate.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Store from "./context/Store";
import rootReducer from "./context/rootReducer";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { recaptcha_token } from "./config";

ReactDOM.render(
  <React.StrictMode>
    <Store rootReducer={rootReducer}>
      <GoogleReCaptchaProvider reCaptchaKey={recaptcha_token}>
        <App />
      </GoogleReCaptchaProvider>
    </Store>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
